import { render } from "./headerCom.vue?vue&type=template&id=09958a16&scoped=true"
import script from "./headerCom.vue?vue&type=script&lang=js"
export * from "./headerCom.vue?vue&type=script&lang=js"

import "./headerCom.vue?vue&type=style&index=0&id=09958a16&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09958a16"]])

export default __exports__